import { useEffect, useState } from 'react';
import useViewer from '@hooks/useViewer';

const useAuthorized = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(null);
    const [isMemberActive, setIsMemberActive] = useState(null);
    const { viewer } = useViewer();

    useEffect(() => {
        if (typeof viewer === 'undefined') {
            return;
        }

        setIsLoggedIn(viewer !== null);
        setIsMemberActive(viewer?.status === 'Active');
    }, [viewer]);

    return { isLoggedIn, isMemberActive };
};

export default useAuthorized;
